import React from 'react';
import './image-overlay.scss';

const ImageOverlay = ({ children, wrapClassName = '' }) => {
  // const overlayRef = React.createRef();
  // const disableContextMenu = e => {
  //   // e.preventDefault && e.preventDefault();
  //   // e.stopPropagation && e.stopPropagation();
  //   // return false;
  // };
  const text = `image-overlay--overlay ${wrapClassName}`;
  return (
    <div className="image-overlay">
      <div className={text} />
      {children}
    </div>
  );
};

export default ImageOverlay;
